import { createApp } from 'vue';
import { createCalendarRouter } from './router'
import { default as CalendarAppParam, CalendarAppParamType } from './composables/application-parameter';
import AppCalendar from './AppCalendar.vue';

// eslint-disable-next-line
export function init(componentName: string, componentData: any): void {
  let app;

  // Create application
  if (componentName === "Calendar" && componentData) {
    const initParams = new CalendarAppParamType(componentData);
    app = createApp(AppCalendar);
    app.use(createCalendarRouter(initParams));
    app.provide(CalendarAppParam, initParams);
  } else {
    console.error(`Unknown component ${componentName}`);
    return;
  }

  app.mount("#cms-vue-app");
}
